"use client";

import { useEffect, useRef } from "react";
import { useSearchParams } from "next/navigation";
import { captureMarketingAttribution } from "~/lib/siteglue/marketing-attribution";

/** Capture UTMs on mount and when marketing query params change. */
export function useMarketingAttributionCapture(): void {
  const searchParams = useSearchParams();
  const lastQuery = useRef<string>("");

  useEffect(() => {
    const query = searchParams?.toString() ?? "";
    if (query === lastQuery.current && lastQuery.current !== "") return;
    lastQuery.current = query;
    captureMarketingAttribution(query ? `?${query}` : undefined);
  }, [searchParams]);
}
